import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVercel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="vercel" maskId="round-filled-radius-1-stroke-1.5-IconVercel"><path d="M11.8632 2.17999L22.7264 20.9958H1L11.8632 2.17999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVercel;
